// apps/fiis3/client/src/api/tickers.ts
import type { Ticker } from '../types.ts'

const BASE = '/api/tickers'

export type TickerImportRecord = {
  ticker: string
  user_id: number
  category_id?: number | null
  qtd?: string
  preco_medio?: string
  cnpj?: string
}

export type UpsertTickersBatchResponse = {
  processed: number
  upserted: number
  records: Ticker[]
}

export async function getTickers(): Promise<Ticker[]> {
  const res = await fetch(BASE)
  if (!res.ok) throw new Error('Erro ao buscar tickers')
  return res.json() as Promise<Ticker[]>
}

export async function getTickersByUser(userId: number): Promise<Ticker[]> {
  const res = await fetch(`${BASE}?user_id=${userId}`)
  if (!res.ok) throw new Error('Erro ao buscar tickers do usuário')
  return res.json() as Promise<Ticker[]>
}

export async function createTicker(data: Omit<Ticker, 'id' | 'created_at'>): Promise<Ticker> {
  const res = await fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Erro ao criar ticker')
  return res.json() as Promise<Ticker>
}

export async function updateTicker(id: number, data: Partial<Omit<Ticker, 'id' | 'created_at'>>): Promise<Ticker> {
  const res = await fetch(`${BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Erro ao atualizar ticker')
  return res.json() as Promise<Ticker>
}

export async function deleteTicker(id: number): Promise<void> {
  const res = await fetch(`${BASE}/${id}`, { method: 'DELETE' })
  if (!res.ok) throw new Error('Erro ao deletar ticker')
}

export async function upsertTickersBatch(
  records: TickerImportRecord[],
): Promise<UpsertTickersBatchResponse> {
  const res = await fetch(`${BASE}/upsert-batch`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ records }),
  })

  if (!res.ok) {
    const errPayload = (await res.json().catch(() => ({}))) as { error?: string }
    throw new Error(errPayload.error ?? 'Erro ao executar upsert em lote')
  }

  return res.json() as Promise<UpsertTickersBatchResponse>
}
